import Component from './Account';

export default Component;
